import { default as Image } from './Image';

export default Image;
